var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8226 14.1148C10.6801 14.1148 10.5376 14.0623 10.4251 13.9498C10.2076 13.7323 10.2076 13.3723 10.4251 13.1548L14.5801 8.99984L10.4251 4.84484C10.2076 4.62734 10.2076 4.26734 10.4251 4.04984C10.6426 3.83234 11.0026 3.83234 11.2201 4.04984L15.7726 8.60234C15.9901 8.81984 15.9901 9.17984 15.7726 9.39734L11.2201 13.9498C11.1076 14.0623 10.9651 14.1148 10.8226 14.1148Z",
    fill: "#747882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2475 9.5625H2.625C2.3175 9.5625 2.0625 9.3075 2.0625 9C2.0625 8.6925 2.3175 8.4375 2.625 8.4375H15.2475C15.555 8.4375 15.81 8.6925 15.81 9C15.81 9.3075 15.555 9.5625 15.2475 9.5625Z",
    fill: "#747882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowRight);
export default __webpack_public_path__ + "static/media/newArrowRight.ca367a862d459f7811d3d5c73f564335.svg";
export { ForwardRef as ReactComponent };